import { Box, Button, Paper, Snackbar, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from '../../../styles.module.css'
import { ActionMsg, Breadcrumb, Cancel, CTSinput, HandleCloseSnackbar, useMessageHandler } from "../../reusableComponent/Reusables";
import SaveIcon from '@mui/icons-material/Save';
import { useDispatch, useSelector } from "react-redux";
import { addUnit, editDeleteUnit } from "../../../actions/actions";
import dayjs from "dayjs";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";



const UnitAdd = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;
    const { handleSubmit } = useForm();
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const editData = editInfo && editInfo;
    const [data, setData] = useState({
        unit_name: editData ? editData.unit_name : '',
        short_name: editData ? editData.short_name : '',
        unit_address: editData ? editData.unit_address : '',
        unit_manager: editData ? editData.unit_manager : '',
        mobile_no: editData ? editData.mobile_no : '',
        unit_id: editData ? editData.unit_id : ''
    });

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }


    const onSubmit = (event) => {
        navigate(-1);
        const unitData = {
            ...data,
            modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            modified_by: editData ? userInfo.user_id : null,
            created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            created_by: editData ? editData.created_by : userInfo.user_id,
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteUnit(unitData));
        } else {
            dispatch(addUnit(unitData));
        }
    }

    let navigate = useNavigate();
    const [successMessage, setSuccessMessage] = useState(null);
    const respMsgState = useSelector((state) => state.unit.message);
    const { shouldShowMsg, responseMessage } = useMessageHandler(
        null,
        // navigate,
        setSuccessMessage,
        respMsgState
    );

    useEffect(() => { }, [shouldShowMsg, responseMessage]);

    return (
        <>
            <Paper className={`${styles.cts_page}`}>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Manufacturing Unit' },
                    ]}
                />
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                        <Grid item md={7} sm={6} xs={12}>
                            <Box sx={{ display: 'flex' }}>
                                <Typography className={`${styles.add_form_title}`}>
                                    {editData ? 'Update' : 'Create'} Manufacturing Unit Master
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box className={`${styles.sm_form}`} >
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '50%', }}>
                        <Grid container spacing={1} sx={{ mt: 0, }} >
                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.cts_lable_sm}`}>Unit Name <span style={{ color: 'red' }}>*</span>  :</Typography>
                            </Grid>
                            <Grid item xs={8} className={`${styles.grid_input}`}>
                                <CTSinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="unit_name"
                                    value={(data.unit_name)}
                                    sx={{ width: '50%' }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.cts_lable_sm}`}>Unit Short Name <span style={{ color: 'red' }}>*</span>  :</Typography>
                            </Grid>
                            <Grid item xs={8} className={`${styles.grid_input}`}>
                                <CTSinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="short_name"
                                    value={(data.short_name)}
                                    sx={{ width: '60%' }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.cts_lable_sm}`}>Unit Address :</Typography>
                            </Grid>
                            <Grid item xs={8} className={`${styles.grid_input}`}>
                                <CTSinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="unit_address"
                                    value={(data.unit_address)}

                                />
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.cts_lable_sm}`}>Unit Manager <span style={{ color: 'red' }}>*</span>  :</Typography>
                            </Grid>
                            <Grid item xs={8} className={`${styles.grid_input}`}>
                                <CTSinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="unit_manager"
                                    value={(data.unit_manager)}
                                    sx={{ width: '60%' }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.cts_lable_sm}`}>Mobile No <span style={{ color: 'red' }}>*</span>  :</Typography>
                            </Grid>
                            <Grid item xs={8} className={`${styles.grid_input}`}>
                                <CTSinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="mobile_no"
                                    value={(data.mobile_no)}
                                    sx={{ width: '40%' }}
                                    required
                                />
                            </Grid>

                            <Grid item xs={12} className={`${styles.grid_input}`}>
                                <Box sx={{ marginTop: '12px', float: 'right' }}>
                                    <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                        <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                    </Button>
                                    <Cancel />
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Paper >
        </>
    )
}
export default UnitAdd;